import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import * as XLSX from 'xlsx';
import * as fromServices from '../../services';
// used by XLSX for compatibility with Chrome
import 'file-saver';
import { LocationInfoModel } from '../../services/common/location-info';

@Component({
  selector: 'hdw-pdf-export',
  templateUrl: './pdf-export.component.html',
  styleUrls: ['./pdf-export.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PdfExportComponent {
  @Input() public canShowPdfExport: boolean;

  constructor(
    private locationService: fromServices.LocationFactoryService,
    private locationState: fromServices.LocationStateService,
    private apiBuilder: fromServices.ApiBuilder
  ) {}

  // only respond to "Enter", but don't interfer with tabbing on Firefox or Spacebar.
  public onPDFKeyPress(event: KeyboardEvent): void {
    if (event.charCode == 13 || event.keyCode == 13) {
      this.onPdf();
    }
  }

  public onExelKeyPress(event: KeyboardEvent): void {
    if (event.charCode == 13 || event.keyCode == 13) {
      this.onExcel();
    }
  }

  public onPdf() {
    window.scrollTo(0, 0);
    const request: fromServices.LocationsRequest = {
      lon: this.locationState.Longitude.toString(),
      lat: this.locationState.Latitude.toString(),
      radius: this.locationState.Radius.toString(),
      heathCenter: this.locationState.HealthCenter,
      checkBoxData: this.locationState.CheckboxData
    };
    let pdfLink = this.apiBuilder.buildUrl(request, this.locationState.ApiMethod);
    pdfLink = pdfLink.replace('/find?', '/pdf?');
    pdfLink = `${pdfLink}&map=true&zoom=${this.locationState.Zoom}`;
    window.location.assign(pdfLink);
  }

  public onExcel() {
    // prevent export if the button is disabled
    // var downloadButton = <HTMLLinkElement>document.getElementById('DownloadLinks');
    // if (downloadButton.classList.contains('link-disabled')) return;
    // generate worksheet using the most recent locations received
    let formattedLocations: any[] = [];
    for (let location of this.locationState.Locations) {
      const formattedRow = this.getExcelDataFromLocation(location);
      formattedLocations.push(formattedRow);
    }

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(formattedLocations);

    // generate workbook and add the worksheet
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // save to file
    const fileName = this.locationService.getExcelFileName() + '.xlsx';
    XLSX.writeFile(workbook, fileName);
  }

  /* get excel row data */
  private getExcelDataFromLocation(location: any): any {
    let hc: LocationInfoModel = Object.assign(new LocationInfoModel(), location);
    return hc.getExcelFormat();
  }

  /* Receive locations from search panel, so export can be formatted and provided directly on the front end;
   no need to call a service. */
  // onResultsReceived(results: any) {
  //   this.locations = results.locations;
  //   const linkBtn = <HTMLLinkElement>document.getElementById('DownloadLinks');
  //   // if, after a search, there are no results, show a message
  //   if (this.locations.length > 0) {
  //     linkBtn.classList.remove('link-disabled');
  //     linkBtn.setAttribute('aria-disabled', 'false');
  //   } else {
  //     linkBtn.classList.add('link-disabled');
  //     linkBtn.setAttribute('aria-disabled', 'true');
  //   }
  // }
}
